import { buildDboRoute } from 'features/db-optimization/v2/routes';
import type { DboParentItem } from 'pages/db-optimization/v2/DbOptimizationControllerV2/types';
import {
  isParentRouteActive,
  useDboPathActive,
} from 'pages/db-optimization/v2/DbOptimizationControllerV2/utils';

import { useLocation } from 'react-router-dom';
import { SidebarItem } from '../../SidebarItem';
import { SidebarTreeGroup } from '../../SidebarTreeGroup';
import { useSidebarSectionExpanded } from '../../useSidebarSectionExpanded';

export const DboParentNavItem = ({
  item,
  params,
}: {
  item: DboParentItem;
  params: Record<string, string>;
}) => {
  const isPathActive = useDboPathActive();
  const { pathname } = useLocation();

  const visibleChildren = item.children.filter((c) => !c.routeOnly);

  const isGroupActive = isParentRouteActive(item, params, isPathActive);

  const { expanded, onToggle } = useSidebarSectionExpanded(
    isGroupActive,
    pathname
  );

  if (visibleChildren.length === 0) return null;

  return (
    <>
      <SidebarItem
        title={item.title}
        to={buildDboRoute(visibleChildren[0].route, params)}
        expanded={expanded}
        indicated={isGroupActive}
        showCaret
        onToggle={onToggle}
      />
      {expanded ? (
        <SidebarTreeGroup>
          {visibleChildren.map((child) => {
            const childPath = buildDboRoute(child.route, params);
            return (
              <SidebarItem
                key={child.route}
                title={child.title}
                to={childPath}
                active={isPathActive(childPath)}
                isNested
              />
            );
          })}
        </SidebarTreeGroup>
      ) : null}
    </>
  );
};
